import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { ApiAttributesMappingService, DialogModalService, LanguageService, NotificationService, PermissionService } from 'src/app/services';
import { ConfirmActionComponent } from '../../../confirm/confirm-action/confirm-action.component';

@Component({
  selector: 'app-attributes-mapping-list',
  templateUrl: './attributes-mapping-list.component.html',
  styleUrls: ['./attributes-mapping-list.component.css']
})
export class AttributesMappingListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  templatesList: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  countSelectedFiles: number = 0;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    public activeModal: NgbActiveModal,
    private apiAttrsMappingService: ApiAttributesMappingService,
    private dialogModal: DialogModalService,
    private notification: NotificationService,
    public permissionAccessService: PermissionService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(
      this.apiAttrsMappingService.listenerAttrMappingListData().subscribe(val => {

        if (val) {

          this.getList();
        }

      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.templatesList = [];

    this.setListParams();

    this.apiAttrsMappingService.getList(this.listParams).subscribe((response: Res) => {
      console.log("RESPONSE_LIST: ", response)

      if (response != null && response.result != null) {

        this.templatesList = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        name: ''
      },
      object: 'attrs_presets',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
   * 
   */
  onCreate() {

    this.apiAttrsMappingService.setAttrMappingData(null);
    this.apiAttrsMappingService.switchTab('actions');
  }
  
  /**
  * 
  * @param ids 
  */
  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  
  /**
  * 
  * @param ids 
  */
  onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttrsMappingService.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.templatesList.filter(val => val.checked).map(({ id }) => id))];
    this.onConfirm(ids);
  }

  /**
 * 
 * @param item 
 */
  onEdit(id: string) {

    this.apiAttrsMappingService.setAttrMappingData(id);
    this.apiAttrsMappingService.switchTab('actions');

  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.templatesList[index].checked = event.target.checked;

    this.counterSelectedFiles();

  }

  /**
   * 
   */
    counterSelectedFiles() {

      this.countSelectedFiles = this.templatesList.filter(val => val.checked).length;
      
    }  


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.templatesList.forEach(x => x.checked = event.target.checked)

    this.counterSelectedFiles();

    this.storageForChekcedFiles();
  }

  /**
   * 
   */
  storageForChekcedFiles() {
    
  this.templatesList.findIndex(i => i.checked);
      
   console.log("SELECTED TAMPLATES: ", this.templatesList);
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.templatesList.length == 0) return false;

    return this.templatesList.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.templatesList.length;
    let pc = this.templatesList.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    let pc = this.templatesList.filter(val => val.checked).length;

    return (pc > 0) ? true : false;
  }


}
